<template>
    <CompassTooltip
        placement="bottom-end"
        arrow
        :disabled="current < max"
        contentClass="card-counter-tooltip"
    >
        <template #content>
            {{ $l10n.__('Vous devez masquer des cartes pour en afficher de nouvelles') }}
        </template>
        <p class="card-counter br m-0" :class="{ 'alert-05-bkg': current >= max }">
            <span ref="count" class="fs-3 lh-20">
                <span class="bold">{{ current }}</span> / {{ max }}
            </span>
            <span class="fs-2">{{ $l10n.__('cartes maximum') }}</span>
        </p>
    </CompassTooltip>
</template>
<script>
export default {
    props: {
        current: {
            type: Number,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;
.card-counter {
    padding: 2px 8px;
    background-color: $gray-0;
    width: fit-content;
}
</style>
<style lang="scss">
.card-counter-tooltip.compass-tooltip__item {
    z-index: 1001;
}
</style>
